
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/team-support",
      function () {
        return require("private-next-pages/team-support.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/team-support"])
      });
    }
  